import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * State and actions
 */

type State = {
  funcionarios: PaginationProperties,
  treinamentos: PaginationProperties,
};

type Action = {
  funcionariosSetter: SetPaginationProperties,
  treinamentosSetter: SetPaginationProperties,
};

/**
 * useGestaoTreinamentosListaPagination
 */

export const useGestaoTreinamentosListaPagination = create<State & Action>((set) => ({
  funcionarios: InitializePaginationProperties(),
  funcionariosSetter: InitializeSetPaginationProperties(set, 'funcionarios'),
  treinamentos: InitializePaginationProperties(),
  treinamentosSetter: InitializeSetPaginationProperties(set, 'treinamentos'),
}));